import React from "react";
import { Subheading } from "../../../../design/heading";
import {
  Table,
  TableBody,
  TableHead,
  TableHeader,
  TableRow,
} from "../../../../design/table";
import { useLocation } from "../../../../contexts/LocationContext";
import CreateLocationButton from "../../../../components/CreateLocationButton";
import LocationLineItem from "./components/LocationLineItem";

interface Props {
  caseId: string;
}

const CaseDetailLocationList: React.FC<Props> = ({ caseId }) => {
  const { locations } = useLocation();
  const caseLocations = locations.filter(
    (location) => location.caseId === caseId,
  );

  return (
    <>
      <div className="flex flex-wrap items-center justify-between w-full">
        <Subheading>Locations</Subheading>
        <div className="flex gap-4">
          <CreateLocationButton caseId={caseId} />
        </div>
      </div>
      {caseLocations.length === 0 && (
        <div className="py-8 text-center">
          <p className="text-sm text-zinc-500 dark:text-zinc-400">No locations have been added yet.</p>
        </div>
      )}
      {caseLocations.length > 0 && (
        <Table className="mt-4 [--gutter:theme(spacing.6)] lg:[--gutter:theme(spacing.10)]">
          <TableHead>
            <TableRow>
              <TableHeader>Name</TableHeader>
              <TableHeader />
            </TableRow>
          </TableHead>
          <TableBody>
            {caseLocations.map((location) => (
              <LocationLineItem key={location.id} location={location} />
            ))}
          </TableBody>
        </Table>
      )}
    </>
  );
};

export default CaseDetailLocationList;
